import { useBrandTheme } from './useTheme';
import { useEffect } from 'react';

const THEME_COLOR_META_SELECTOR = 'meta[name="theme-color"]';

const ensureThemeColorMeta = (): HTMLMetaElement => {
  const existingMeta = document.querySelector<HTMLMetaElement>(THEME_COLOR_META_SELECTOR);

  if (existingMeta) {
    return existingMeta;
  }

  const meta = document.createElement('meta');
  meta.name = 'theme-color';
  document.head.append(meta);

  return meta;
};

const getCanvasTopColor = (): string => {
  const color = getComputedStyle(document.documentElement).getPropertyValue('--color-bg-canvas-top').trim();

  return color || '#f7f7f5';
};

const ThemeColorMeta = () => {
  const { theme } = useBrandTheme();

  useEffect(() => {
    let animationFrameId: number | null = null;

    const syncThemeColor = () => {
      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = window.requestAnimationFrame(() => {
        ensureThemeColorMeta().content = getCanvasTopColor();
        animationFrameId = null;
      });
    };

    const observer = new MutationObserver(syncThemeColor);
    observer.observe(document.documentElement, {
      attributeFilter: ['class', 'style'],
      attributes: true
    });

    syncThemeColor();

    return () => {
      observer.disconnect();

      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, [theme]);

  return null;
};

export default ThemeColorMeta;